import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { invalidOrExpiredLinkRoute } from '#/routing/routes';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { InvalidLinkPageLoadable } from './InvalidLinkPageLoadable';

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof invalidOrExpiredLinkRoute>,
) {
  await InvalidLinkPageLoadable.load();
}

export default function InvalidLinkHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <InvalidLinkPageLoadable />;
}
